
    <h1 mat-dialog-title>{{data && data.title || 'Please confirm your action'}}</h1>
    <div mat-dialog-content>
      <mat-list class="mat-dialog-data-list">
        <h3 mat-subheader>You have domains without complete ads.txt records. If you still want to assign them to this unit expect lower
          revenue</h3>
        <div class="d-flex flex-column">
          <span *ngFor="let domain of data.domains">{{domain.url}}</span>
        </div>
      </mat-list>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end">
      <button mat-raised-button mat-dialog-close cdkFocusInitial>Cancel</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true">{{data?.confirmButtonText || 'Yes!'}}</button>
    </div>
  